import React from 'react';

/**
 * The threshold between worlds — a horizontal line of deep orange glow
 * pulsing across the screen as the user crosses mid-depth.
 */
export const ThresholdLine = () => (
  <div className="pointer-events-none relative w-[72vw] max-w-3xl" data-testid="threshold-line">
    <div className="threshold-core h-px w-full animate-pulse-line" />
    <div className="threshold-halo absolute inset-x-0 -top-2.5 h-6 blur-lg animate-pulse-line" />
    <p className="mt-8 text-center font-serif italic text-cream-warm text-sm tracking-wide">below, something older waits</p>
  </div>
);
